import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAIL,
  GET_UNREAD_COUNT,
  GET_UNREAD_COUNT_SUCCESS,
  GET_UNREAD_COUNT_FAIL,
  ADD_NOTIFICATION,
  ADD_NOTIFICATION_SUCCESS,
  ADD_NOTIFICATION_FAIL,
  UPDATE_NOTIFICATION,
  UPDATE_NOTIFICATION_SUCCESS,
  UPDATE_NOTIFICATION_FAIL,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAIL,
  MARK_NOTIFICATION_AS_SEEN,
  MARK_NOTIFICATION_AS_SEEN_SUCCESS,
  MARK_NOTIFICATION_AS_SEEN_FAIL,
  RESET_NOTIFICATION_FLAG,
} from "./actionTypes"

const INIT_STATE = {
  lstNotifications: [],
  unreadCount: 0,
  error: "",
  success: "",
  loading: false,
}

const Notifications = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get Notifications
    case GET_NOTIFICATIONS:
      return {
        ...state,
        loading: true,
      }

    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        lstNotifications: action.payload,
      }

    case GET_NOTIFICATIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Get Unread Count
    case GET_UNREAD_COUNT:
      return {
        ...state,
      }

    case GET_UNREAD_COUNT_SUCCESS:
      return {
        ...state,
        unreadCount: action.payload,
      }

    case GET_UNREAD_COUNT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    // Add Notification
    case ADD_NOTIFICATION:
      return {
        ...state,
        loading: true,
      }

    case ADD_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        lstNotifications: [action.payload, ...state.lstNotifications],
        success: "اطلاعیه با موفقیت ایجاد شد",
      }

    case ADD_NOTIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Update Notification
    case UPDATE_NOTIFICATION:
      return {
        ...state,
        loading: true,
      }

    case UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        lstNotifications: state.lstNotifications.map(notification =>
          notification.id === action.payload.id
            ? { ...notification, ...action.payload }
            : notification
        ),
        success: "اطلاعیه با موفقیت بروزرسانی شد",
      }

    case UPDATE_NOTIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Delete Notification
    case DELETE_NOTIFICATION:
      return {
        ...state,
        loading: true,
      }

    case DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        lstNotifications: state.lstNotifications.filter(
          notification => notification.id !== action.payload
        ),
        success: "اطلاعیه با موفقیت حذف شد",
      }

    case DELETE_NOTIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Mark as Seen
    case MARK_NOTIFICATION_AS_SEEN:
      return {
        ...state,
      }

    case MARK_NOTIFICATION_AS_SEEN_SUCCESS:
      return {
        ...state,
        lstNotifications: state.lstNotifications.map(notification =>
          notification.id === action.payload
            ? { ...notification, status: 3, statusName: "مشاهده شده", seenDate: new Date().toISOString() }
            : notification
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      }

    case MARK_NOTIFICATION_AS_SEEN_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    // Reset Flag
    case RESET_NOTIFICATION_FLAG:
      return {
        ...state,
        error: "",
        success: "",
      }

    default:
      return state
  }
}

export default Notifications
